import {
  has, some, keys, flatten, constant,
  uniqueId, difference, isFunction,
  isPlainObject, camelCase, upperFirst
} from 'lodash-es'

const debugName = (name) => '_' + (/^[A-Z]/.test(name) ? upperFirst(camelCase(name)) : camelCase(name))

import deline from './deline'
import envRaw from './env-raw'
import deleteGlobal from './delete-global'

const exposeName = 'ggsDebugRaw'

const addPair = (name, val) => {
  const keyName = debugName(name)
  if (has(debugRaw, keyName) && debugRaw[keyName] !== val) {
    const newName = uniqueId(`${keyName}_`)
    console.warn(deline(`
      debugRaw:
        already has [name=${name}]
        as [keyName=${keyName}].
        Will use [newName=${newName}] instead!`))
    debugRaw[newName] = val
  } else {
    debugRaw[keyName] = val
  }
  return val
}

const addObject = (object) =>
  keys(object).forEach((name) => addPair(name, object[name]))

const debugRaw = (name, val) => isPlainObject(name)
  ? addObject(name)
  : addPair(name, val)

debugRaw.clear = () => {
  const allKeys = keys(debugRaw)
  const userKeys = difference(allKeys, internalKeys)
  userKeys.forEach((key) => delete debugRaw[key])
  return debugRaw
}

debugRaw.remove = (...rawValues) => {
  const values = flatten(rawValues)
  keys(debugRaw)
    .filter((key) => some(values, (val) => val === debugRaw[key]))
    .forEach((key) => delete debugRaw[key])
  return debugRaw
}

debugRaw.disable = () => {
  deleteGlobal(exposeName)
  return debugRaw
}

const internalKeys = keys(debugRaw)

let exports = null

if (envRaw.useDebugRaw) {
  const defined = isFunction(window[exposeName])
  exports = defined
    ? window[exposeName]
    : window[exposeName] = debugRaw
} else {
  const mock = (_name, val) => val
  mock.clear = constant(mock)
  mock.remove = constant(mock)
  mock.disable = constant(mock)
  exports = mock
}

export default exports
